"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = void 0;

var domhandler_1 = require("domhandler");

var default_1 = require("./default");
/**
 * Configuration for Payload CMS
 *
 * Tested for v1.1.21
 */


exports.config = Object.assign(Object.assign({}, default_1.config), {
  elementTransforms: Object.assign(Object.assign({}, default_1.config.elementTransforms), {
    link: function link(_ref) {
      var node = _ref.node,
          _ref$children = _ref.children,
          children = _ref$children === void 0 ? [] : _ref$children;
      var attrs = {};

      if (node.linkType) {
        attrs['data-link-type'] = node.linkType;
      }

      if (node.newTab) {
        attrs.target = '_blank';
      }

      return new domhandler_1.Element('a', Object.assign({
        href: node.url
      }, attrs), children);
    },
    upload: function upload(_ref2) {
      var node = _ref2.node;

      var _a, _b, _c, _d, _e, _f;

      if (((_a = node.value) === null || _a === void 0 ? void 0 : _a.mimeType) && ((_b = node.value) === null || _b === void 0 ? void 0 : _b.url)) {
        if ((_c = node.value) === null || _c === void 0 ? void 0 : _c.mimeType.match(/^image/)) {
          return new domhandler_1.Element('img', {
            src: (_d = node.value) === null || _d === void 0 ? void 0 : _d.url
          });
        }

        return new domhandler_1.Element('a', {
          href: (_e = node.value) === null || _e === void 0 ? void 0 : _e.url
        }, [new domhandler_1.Text((_f = node.value) === null || _f === void 0 ? void 0 : _f.filename)]);
      }

      return;
    }
  }),
  defaultTag: 'p'
});